import { XAIHeader } from 'ui/slideOver';
import { TEST_IDS, XAI_HEADER_TILE_TEXT } from '../../constants';

export const XaiSlideOverHeader = () => {
  return (
    <div data-test={TEST_IDS.XAISlideOvertHeader}>
      <XAIHeader>{XAI_HEADER_TILE_TEXT}</XAIHeader>
    </div>
  );
};
